import { Skeleton } from "antd";
import SectionCardSkeleton from "./SectionCardSkeleton";

const LifecycleTimelineSkeleton = () => (
    <SectionCardSkeleton>
        <Skeleton active title={{ width: "35%" }} paragraph={false} className="!mb-4" />
        <div className="flex flex-col gap-4 pl-2">
            {Array.from({ length: 8 }).map((_, index) => (
                <div key={index} className="flex items-start gap-3">
                    <Skeleton.Avatar active size={12} shape="circle" />
                    <Skeleton active paragraph={{ rows: 1, width: index === 0 ? "70%" : "55%" }} className="flex-1" />
                </div>
            ))}
        </div>
    </SectionCardSkeleton>
);

export default LifecycleTimelineSkeleton;
